
import { DefaultState, Filters } from 'store/types';

export const ROOM_EXPORT_EXCEL_REQUEST = 'ROOM_EXPORT_EXCEL_REQUEST';
export const ROOM_EXPORT_EXCEL_SUCCESS = 'ROOM_EXPORT_EXCEL_SUCCESS';
export const ROOM_EXPORT_EXCEL_FAILURE = 'ROOM_EXPORT_EXCEL_FAILURE';

export interface RoomExportExcelParams {
  filters: Filters;
  rowsCount: number;
};

export type RoomExportExcelState = DefaultState & {
  contents?: {};
};

interface RoomExportExcelRequest {
  type: typeof ROOM_EXPORT_EXCEL_REQUEST;
};

interface RoomExportExcelSuccess {
  type: typeof ROOM_EXPORT_EXCEL_SUCCESS,
  contents: {};
}

interface RoomExportExcelFailure {
  type: typeof ROOM_EXPORT_EXCEL_FAILURE;
}

export type RoomExportExcelActionTypes = RoomExportExcelRequest | RoomExportExcelSuccess | RoomExportExcelFailure;